<!-- <div class="row">
    <div class="col-md-12">
        <h2>Exam Related Issue</h2>
    </div>

    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Total</b></h4>
                <p>{{this.eristatuslistcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b> Pending</b></h4>
                <p>{{this.eristatuspendingcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Resolved</b></h4>
                <p>{{this.eristatusresolvecount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Rejected</b></h4>
                <p>{{this.eristatusrejectcount}}</p>
            </div>
        </div>
    </div>
    <hr>
</div> -->


<div class="row">
    <div class="col-md-12">
        <h2> Total Bulk/Single Payment Related Issue </h2>
    </div>

    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Total</b></h4>
                <p>{{this.bdnustatuscount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b> Pending</b></h4>
                <p>{{this.pdustatuspendingcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Resolved</b></h4>
                <p>{{this.pdustatusresolvecount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Rejected</b></h4>
                <p>{{this.pdustatusrejectcount}}</p>
            </div>
        </div>
    </div>

    
</div>
<hr>
<div class="row">
    <div class="col-md-12">
        <h2>Single  Payment Related Issue </h2>
    </div>

<!--SINGLE-->
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b> single Total</b></h4>
                <p>{{this.singletotalcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Single Pending</b></h4>
                <p>{{this.singlependingcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Single Resolved</b></h4>
                <p>{{this.singleresolvecount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Single Rejected</b></h4>
                <p>{{this.singlerejectcount}}</p>
            </div>
        </div>
    </div>
</div>
<hr>
<!--BULK-->
<div class="row">
<div class="col-md-12">
    <h2> Bulk Payment Related Issue </h2>
</div>

<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b> Bulk Total</b></h4>
            <p>{{this.bulktotalcount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Bulk Pending</b></h4>
            <p>{{this.bulkpendingcount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Bulk Resolved</b></h4>
            <p>{{this.bulkresolvecount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Bulk Rejected</b></h4>
            <p>{{this.bulkrejectcount}}</p>
        </div>
    </div>
</div>
</div>

<hr>

<div class="row">
    <div class="col-md-12">
        <h2> Direct NIMI Payment Related Issue </h2>
    </div>

<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b> Direct NIMI Total</b></h4>
            <p>{{this.dirnimitotalcount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Direct NIMI Pending</b></h4>
            <p>{{this.dirnimipendingcount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Direct NIMI Resolved</b></h4>
            <p>{{this.dirnimiresolvecount}}</p>
        </div>
    </div>
</div>
<div class="col-md-3">
    <div class="card">
        <div class="container">
            <h4><b>Direct NIMI Rejected</b></h4>
            <p>{{this.dirnimirejectcount}}</p>
        </div>
    </div>
</div>


</div>
<hr>

<!--BULK-->



<div class="row">
  <!-- <div class="col-md-12">
      <h2> Payment verified details </h2>
  </div> -->

  <!-- <div class="col-md-3">
      <div class="card" routerLink="/dashboard/adminreport">
          <div class="container">
              <h4><b>Shipped</b></h4>
              <p>{{this.shippedCount}}</p>
          </div>
      </div>
  </div> -->
  <!-- <div class="col-md-3">
      <div class="card">
          <div class="container">
              <h4><b> Pending</b></h4>
              <p>{{this.pdustatuspendingcount}}</p>
          </div>
      </div>
  </div>
  <div class="col-md-3">
      <div class="card">
          <div class="container">
              <h4><b>Resolved</b></h4>
              <p>{{this.pdustatusresolvecount}}</p>
          </div>
      </div>
  </div>
  <div class="col-md-3">
      <div class="card">
          <div class="container">
              <h4><b>Rejected</b></h4>
              <p>{{this.pdustatusrejectcount}}</p>
          </div>
      </div>
  </div> -->
</div>


<div class="row">
    <div class="col-md-12">
        <h2> Bulk/Single Payment CC verified pending details </h2>
    </div>
  
    <div class="col-md-3">
        <div class="card" routerLink="/dashboard/adminreport">
            <div class="container">
                <h4><b>Verified</b></h4>
                <p>{{this.ccverifycount}}</p>
            </div>
        </div>
    </div>
</div>

<!-- <div class="row">
    <div class="col-md-12">
        <h2>Candidate Related Issue</h2>
    </div>

    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Total</b></h4>
                <p>{{this.cricount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b> Pending</b></h4>
                <p>{{this.cripendingcount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Resolved</b></h4>
                <p>{{this.criresolvecount}}</p>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card">
            <div class="container">
                <h4><b>Rejected</b></h4>
                <p>{{this.crirejectcount}}</p>
            </div>
        </div>
    </div>
</div>
<hr> -->
